import React, { forwardRef } from 'react'
import { Layout, Header } from '../../Components/Layout/Layout'
import Helpers from '../../Components/Helpers/Helpers'
import Dropdown from 'react-bootstrap/Dropdown'
import { useSelector } from 'react-redux'
import { notificationSaleEcommerce } from '../../Redux/Actions'
import Store from '../../Redux/Store';
import Controllers from '../../Api/Controllers'
import { useHistory } from 'react-router-dom'

const CustomToggle = forwardRef(({ children, onClick }, ref) => {

  const filePhotoUser = useSelector(store => store.session.file_photo_user)

  return (
    <div className="system-devs-header-icon" ref={ref} onClick={(e) => {
      e.preventDefault()
      onClick(e)
    }}
    >
      <img className="system-devs-header-avatar" src={Helpers.config.resourcesUrl({ url: filePhotoUser })} alt="Perfil" />
      {children}
    </div>
  )
})



const AppLayout = ({ title, children, page, showBread, hideTop }) => {
  const fullName = useSelector(store => store.session.full_name)
  const permissions = useSelector(store => store.session.permissions)
  const type = useSelector(store => store.session.type)
  const notifications = useSelector(store => store.session.notifications)
  const mainProfile = useSelector(store => store.session.main_profile)

  console.log('type', type)

  const history = useHistory();

  const handleLogout = () => {
    Helpers.localStorage.clearJWT();
    window.location.href = Helpers.config.convertUrl({ url: '/' + (parseInt(type) === 1 ? 'login/empresariosindependientes' : '') });
  }
  const Logo = Helpers.config.resourcesUrl({ url: '/images/dashboard/logo.png' })

  const CustomToggle2 = forwardRef(({ children, onClick }, ref) => {
    return (
      <div className="system-devs-header-icon" ref={ref} onClick={(e) => {
        e.preventDefault()
        onClick(e)
      }}
      >
        <div className='position-relative'>
          <i className='fa fa-bell'></i>
          {notifications.sale_ecommerce.filter(r => {
            return parseInt(r.is_read) === 0
          }).length > 0 && <div className="position-absolute" style={{
            top: -1,
            left: 5,
            background: '#ff3636',
            width: 10,
            height: 10,
            borderRadius: 10,
            zIndex: 99
          }}></div>}
        </div>
        {children}
      </div>
    )
  })

  return <Layout
    forCustomer={type === 1}
    mainPage={mainProfile}
    resizeNav
    imageLogo={Logo}
    permissions={type === 1 ? permissions.filter(p => {
      p.childrens = p.childrens.filter(c => {
        c.childrens = c.childrens.filter(ch => {
          return ch.a_href === 'mi-equipo' || ch.a_href === 'mi-cuenta' || ch.a_href === 'dashboard' || ch.a_href === 'ecommerce' || ch.a_href === 'registrar-cliente'
        })

        return c
      })

      return p
    }) : permissions}
    title={title}
    page={page}
    companyName={Helpers.config.company.name}
    folderPath={Helpers.config.convertUrl({ url: '/' })}
    iconsHeader={[
      <>
        <Dropdown className='notification-dropdown'>
          <Dropdown.Toggle variant="success" as={CustomToggle2} />
          <Dropdown.Menu className="notification-dropdown-menu">
            {notifications.sale_ecommerce.length === 0 && <div className='text-center'>
              <small>No hay notificaciones</small>
            </div>}
            {React.Children.toArray([
              ...notifications.sale_ecommerce,
            ].map(item => {
              return <Dropdown.Item className="d-flex flex-column" onClick={_ => {
                Controllers.users.notification_read({
                  p_id_notification: item.id_notification
                })
                Store.dispatch(notificationSaleEcommerce(item.id_notification))
                history.push(Helpers.config.convertUrl({ url: '/ventas' }))
              }}>
                <div className='d-flex justify-content-between'>
                  <span className='badge badge-info align-self-start'>Venta Ecommerce</span>
                  <div className='align-self-center'>
                    <i className='fa fa-check-double' style={{
                      opacity: parseInt(item.is_read) === 1 ? 1 : 0.3,
                      color: parseInt(item.is_read) === 1 ? '#0f5969' : '',
                    }}></i>
                  </div>
                </div>
                <small><strong>ID Venta:</strong> {item.id_sale}</small>
                <small><strong>ID Cliente:</strong> {item.id_customers}</small>
                <small><strong>Cliente:</strong> {item.full_name_customers}</small>
                <small><strong>Sucursal:</strong> {item.key_branch_office} - {item.name_branch_office}</small>
                <small><strong>Periódo</strong>: {item.code_period} - {item.name_period}</small>
              </Dropdown.Item>
            }))}
          </Dropdown.Menu>
        </Dropdown>
        <div className="header-user-name align-self-center d-none d-sm-block">
          {fullName}
        </div>
        <Dropdown>
          <Dropdown.Toggle variant="success" as={CustomToggle} />
          <Dropdown.Menu>
            <Dropdown.Item className="d-flex" onClick={handleLogout}>
              <i className="fa fa-arrow-left mr-2 align-self-center"></i>
              <span>Salir</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </>,
    ]}
    showBread={showBread}
    hideTop={hideTop}
  >
    {children}
  </Layout>
}

AppLayout.defaultProps = {
  title: '',
  page: ''
}

export default AppLayout
